import axios from "axios";

export default {
  async list() {
    const response = await axios({
      method: "get",
      url: `/api/salesforce/account`,
    });

    return response.data.result;
  },

  async get(id) {
    const response = await axios({
      method: "get",
      url: `/api/salesforce/${id}`,
    });

    return response.data.result;
  },
};
